export default "__VITE_ASSET__xG7wcRvm__"